class DropFitnessAuthBackend {

    constructor(dropfitnessConfig: any) {
        if (dropfitnessConfig) {
            // Initialize DropFitness
        }
    }

    /**
     * Registers the user with given details
     */
    registerUser = (email: any, password: any) => {
        return new Promise((resolve, reject) => {
            // firebase.auth().createUserWithEmailAndPassword(email, password).then((user: any) => {
            //     var user: any = firebase.auth().currentUser;
            //     resolve(user);
            // }, (error: any) => {
            //     reject(this._handleError(error));
            // });
        });
    }

    /**
     * Login user with given details
     */
    loginUser = (email: any, password: any) => {
        return new Promise((resolve, reject) => {
            // firebase.auth().signInWithEmailAndPassword(email, password).then((user: any) => {
            //     // eslint-disable-next-line no-redeclare
            //     var user: any = firebase.auth().currentUser;
            //     resolve(user);
            // }, (error: any) => {
            //     reject(this._handleError(error));
            // });
        });
    }

    /**
     * Logout the user
     */
    logout = () => {
        return new Promise((resolve, reject) => {
            // firebase.auth().signOut().then(() => {
            //     resolve(true);
            // }).catch((error: any) => {
            //     reject(this._handleError(error));
            // });
        });
    }

    /**
     * forget Password user with given details
     */
    forgetPassword = (email: any) => {
        return new Promise((resolve, reject) => {
            // tslint:disable-next-line: max-line-length
            // firebase.auth().sendPasswordResetEmail(email, { url: window.location.protocol + '//' + window.location.host + '/login' }).then(() => {
            //     resolve(true);
            // }).catch((error: any) => {
            //     reject(this._handleError(error));
            // });
        });
    }

    setLoggeedInUser = (user: any) => {
        sessionStorage.setItem('authUser', JSON.stringify(user));
    }

    /**
     * Returns the authenticated user
     */
    getAuthenticatedUser = () => {
        if (!sessionStorage.getItem('authUser')) {
            return null;
        }
        return JSON.parse(sessionStorage.getItem('authUser')!);
    }

    /**
     * Handle the error
     * @param {*} error
     */
    _handleError(error: any) {
        // tslint:disable-next-line: prefer-const
        var errorMessage = error.message;
        return errorMessage;
    }
}

// tslint:disable-next-line: variable-name
let _dropfitnessBackend: DropFitnessAuthBackend | null = null;

/**
 * Initilize the backend
 * @param {*} config
 */
const initDropfitnessBackend = (config: any) => {
    if (!_dropfitnessBackend) {
        _dropfitnessBackend = new DropFitnessAuthBackend(config);
    }
    return _dropfitnessBackend;
};

/**
 * Returns the firebase backend
 */
const getDropfitnessBackend = () => {
    return _dropfitnessBackend;
};

export { initDropfitnessBackend, getDropfitnessBackend };
